<mat-form-field [appearance]="appearance">
	<!-- <button (click)="isPlain = !isPlain">Show password (à déplacer avec un icon eye à la fin de l'input, il faudra hold le click)</button> -->
	<input
		*ngIf="!isPlain"
		type="password"
		matInput
		[formControl]="control"
		[name]="control.name"
		[placeholder]="placeholder"
		[errorStateMatcher]="matcher"
	/>
	<input
		*ngIf="isPlain"
		type="text"
		matInput
		[formControl]="control"
		[name]="control.name"
		[placeholder]="placeholder"
		[errorStateMatcher]="matcher"
	/>

	<mat-icon matSuffix (click)="isPlain = !isPlain">{{ isPlain ? 'visibility_off' : 'visibility' }}</mat-icon>

	<!-- https://github.com/angular/material2/issues/7739 : Vive la bidouille ! -->
	<ng-template ngFor let-key [ngForOf]="control.validationKeys" ngProjectAs="mat-error">
		<mat-error *ngIf="control.hasError(key)">
			{{ control.getErrorMessage(key) }}
		</mat-error>
	</ng-template>
</mat-form-field>
